import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export default {
  getQuestions() {
    return RetailerApiClient.get('questions')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },

  getQuestionsByTargetType(targetType) {
    return RetailerApiClient.get(`questions/${targetType}`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },

  getApplicationCancellationQuestions(id) {
    return RetailerApiClient.get('questions/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },

  getRetailerQuestions() {
    return RetailerApiClient.get('retailer-questions')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },

  saveRetailersAnswers(answers) {
    return RetailerApiClient.post('retailer-questions', answers)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
